function nativeDetectorApiEnabled() {
  return 'FaceDetector' in window;
}

async function nativeDetectorSupported() {
  console.log('[native-detector] checking if native detector is supported');
  try {
    const fd = new FaceDetector();
    const canvas = document.createElement('canvas');
    await fd.detect(canvas);
    console.log('[native-detector] native detector is supported');
    return true;
  } catch (e) {
    console.log('[native-detector] native detector is not supported', e.name);
    return false;
  }
}

export async function nativeDetectorAvailable() {
  const apiEnabled = nativeDetectorApiEnabled();
  const supported = await nativeDetectorSupported();
  console.log('[native-detector] native detector availability', { apiEnabled, supported });
  return apiEnabled && supported;
}
